import React from "react";
import useAddJewellery, { jewelleryMediaType } from "../hooks/useAddJewellery";
import {
  DragDropContext,
  Draggable,
  DropResult,
  Droppable,
} from "react-beautiful-dnd";
import { UploadCloud, X } from "lucide-react";
import Dropzone from "react-dropzone";
import DeleteModal from "Common/DeleteModal";

const JewelleryMedia = ({
  jewelleryMedia,
  setJewelleryMedia,
  deletedImagesUrls,
  setDeletedImagesUrls,
  isShowError,
}: // mediaErrors,
  {
    jewelleryMedia: jewelleryMediaType[];
    setJewelleryMedia: (val: jewelleryMediaType[]) => void;
    deletedImagesUrls: string[];
    setDeletedImagesUrls: (val: string[]) => void;
    isShowError: boolean;
    // mediaErrors: any;
  }) => {
  const {
    // jewelleryMedia,
    isDuplicate,
    isEditing,
    isLoading,
    onDragEnd,
    handleAcceptfiles,
    setMediaEventData,
    isShowDeleteModel,
    setIsShowDeleteModel,
    handleDelete,
    // isShowError,
  } = useAddJewellery({ jewelleryMedia, setJewelleryMedia, deletedImagesUrls, setDeletedImagesUrls });

  return (
    <>
      <DeleteModal
        show={isShowDeleteModel}
        onHide={() => {
          setIsShowDeleteModel(false);
        }}
        onDelete={handleDelete}
        message="Are you certain you want to delete this media?"
      />
      {jewelleryMedia.map((data: any, i: number) => {
        const images = isEditing ? data.images : data.files;
        return (
          <div
            className="lg:col-span-2 xl:col-span-12"
            key={`product-images-${i}`}
          >
            <label
              htmlFor={`upload-${data.type}-Images`}
              className="inline-block mb-2 text-base font-medium"
            >
              {data.label}
            </label>
            <div
              className={`flex flex-wrap ${data?.images?.length || data?.files?.length ? "gap-x-1" : ""
                } `}
              id={`upload-${data.type}-Images`}
            >
              <DragDropContext
                onDragEnd={(result: DropResult) => onDragEnd(result, i)}
              >
                <Droppable
                  droppableId={`dropzone-preview-${i}`}
                  direction="horizontal"
                >
                  {(provided: any) => (
                    <ul
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                      className="flex flex-wrap mb-0 gap-x-1"
                    >
                      {data.images?.map((data: any, index: number) => (
                        <Draggable
                          key={`dropzone-preview-list-${index}-${i}`}
                          draggableId={`dropzone-preview-list-${index}-${i}`}
                          index={index}
                        >
                          {(provided: any) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className="w-20 h-20 relative"
                              id={`dropzone-preview-list-${index}-${i}`}
                            >
                              <li className="h-full">
                                <div className="border rounded border-slate-200 dark:border-zink-500 h-full">
                                  <div className="p-2 text-center ">
                                    <div>
                                      <div className="mx-auto rounded-md size-14 bg-slate-100 dark:bg-zink-600">
                                        <img
                                          className="block w-full h-full rounded-md"
                                          src={data}
                                          // src={isEditing ? data : data.preview}
                                          alt={
                                            data?.split("/")[
                                            data?.split("/").length - 1
                                            ]
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <button
                                className="absolute top-0 right-0 opacity-0 hover:opacity-100 text-red  hover:bg-red-500/10 disabled:hover:opacity-50 disabled:cursor-not-allowed p-1"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setMediaEventData({
                                    index: i,
                                    fileIndex: index,
                                  });
                                  setIsShowDeleteModel(true);
                                }}
                                disabled={isLoading}
                              >
                                <X size={15} className="text-red-500" />
                              </button>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {data.files?.map((data: any, index: number) => (
                        <Draggable
                          key={`dropzone-preview-list-${index}-${i}`}
                          draggableId={`dropzone-preview-list-${index}-${i}`}
                          index={index}
                        >
                          {(provided: any) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className="w-20 h-20 relative"
                              id={`dropzone-preview-list-${index}-${i}`}
                            >
                              <li className="h-full">
                                <div className="border rounded border-slate-200 dark:border-zink-500 h-full">
                                  <div className="p-2 text-center ">
                                    <div>
                                      <div className="mx-auto rounded-md size-14 bg-slate-100 dark:bg-zink-600">
                                        <img
                                          className="block w-full h-full rounded-md"
                                          src={data.preview}
                                          // src={isEditing ? data : data.preview}
                                          alt={data.name}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                              <button
                                className="absolute top-0 right-0 opacity-0 hover:opacity-100 text-red  hover:bg-red-500/10 disabled:hover:opacity-50 disabled:cursor-not-allowed p-1"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setMediaEventData({
                                    index: i,
                                    fileIndex: index,
                                  });
                                  setIsShowDeleteModel(true);
                                }}
                                disabled={isLoading}
                              >
                                <X size={15} className="text-red-500" />
                              </button>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </ul>
                  )}
                </Droppable>
              </DragDropContext>
              <Dropzone
                onDrop={(acceptfiles) => {
                  handleAcceptfiles(acceptfiles, i);
                }}

                disabled={isLoading}
              >
                {({ getRootProps, getInputProps }) => (
                  <div
                    className="flex items-center justify-center bg-white border border-dashed rounded-md cursor-pointer dropzone border-slate-300 dark:bg-zink-700 dark:border-zink-500 dropzone2 min-h-20 w-20 h-20 disabled:cursor-not-allowed"
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    <div className="w-full py-5 text-lg text-center dz-message needsclick" >
                      <div className="">
                        <UploadCloud className="block size-6 mx-auto text-slate-500 fill-slate-200 dark:text-zink-200 dark:fill-zink-500" />
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>
            {/* {!data?.files?.length && !data?.images?.length && isShowError && (
              <div className="text-red-500">
                Please upload at least one file for {data.type}.
              </div>
            )} */}
          </div>
        );
      })}
    </>
  );
};

export default JewelleryMedia;
